import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterStatesByType',
    standalone: false
})
export class FilterStatesByTypePipe implements PipeTransform {
  transform(states: any[], type: number): any[] {
    if (!states || (type !== 0 && !type)) {
      return [];
    }
    return states
      .filter(state => state.type === type)
      .sort((a, b) => (a.state ?? 0) - (b.state ?? 0));
  }
}
